// eslint-disable-next-line import/no-anonymous-default-export
export default {
    NORMAL: 0,
    PRAZO: 1,
    DEBITO_MULTA: 2,
    MEDIDA_CAUTELAR: 3,
    CIRCULAR: 4
}